import React, {useEffect, useState} from 'react';
import {Loader2, Pencil, Plus, X} from "lucide-react";
import axios from "axios";
import {toast} from "sonner";
import {useAuth} from "../Context/AuthContext";
import {useNavigate} from "react-router-dom";

const initialData = {
    code: "",
    name: "",
    symbol: "",
    exchange_rate: 0
}


const Currency = () => {
    const [loading, setLoading] = useState(false);
    const [currency, setCurrency] = useState([]);
    const {getToken} = useAuth();
    const token = getToken();
    const navigate = useNavigate();
    const [openEditModal, setOpenEditModal] = useState(false);
    const [formData, setFormData] = useState(initialData);
    const [selectedId, setSelectedId] = useState(null);
    const [isUpdating, setIsUpdating] =  useState(false);
    const [refresh, setRefresh] = useState(false);





    const handleCloseModal = () => {
        setOpenEditModal(false);
        setFormData(initialData);
        setSelectedId(null);
    };

    const handleCreateAndUpdateCurrency = async (id) => {

        const payload = {
            code: formData?.code,
            name: formData?.name,
            symbol: formData?.symbol,
            exchange_rate: formData?.exchange_rate
        }

        try {
            if (!payload?.code) {
                toast.error("Currency code is required.");
                return;
            }
            if (!payload?.name) {
                toast.error("Currency name is required.");
                return;
            }
            if (!payload?.symbol) {
                toast.error("Currency symbol is required.");
                return;
            }
            if (!payload?.exchange_rate) {
                toast.error("Currency exchange rate is required.");
                return;
            }

            setIsUpdating(true);
            const res = await fetch(
                `https://apisellhub.com/api/super-admin/currencies${id? `/${id}`: ''}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );
            const data = await res.json();
            if (data.status) {
                // success
                toast.success(data?.message || `Currency ${id? 'update': 'add'} successfully.`);
                setOpenEditModal(false);
                setRefresh(!refresh);
            } else {
                // error from server
                toast.error(data?.message || `Failed to ${id? 'update': 'add'} currency.`);
            }
        } catch (err) {
            console.log(err);
            // setError(err?.message || "Failed to fetch currency.");
            toast.error(err?.message || "Failed to update currency.");
        } finally {
            setIsUpdating(false);
        }
    }


    useEffect(() => {
        const fetchCurrency = async () => {
            try {
                setLoading(true);
                // setError(null);

                if (!token) {
                    // setError("No authentication token found");
                    setLoading(false);
                    return;
                }

                const response = await axios.get(
                    `https://apisellhub.com/api/super-admin/currencies`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.data.status) {
                    setCurrency(response.data.data);
                } else {
                    setCurrency([]);
                }
            } catch (err) {
                console.error("Sellers API error:", err);
                if (err.response?.status === 401) {
                    navigate("/center/login", {replace: true});
                    sessionStorage.removeItem("Market-token");
                    toast.error("Token Expired. Please login again.");
                } else {
                    toast.error("Failed to load sellers data");
                }
            } finally {
                setLoading(false);
            }
        };
        if(token){
            fetchCurrency().then()
        }
        // eslint-disable-next-line
    }, [refresh, token])

    // Loading state
    if (loading) {
        return (
            <div className="space-y-6">
                {/* Header Skeleton */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        <div className="h-8 bg-gray-600 rounded w-32 mb-2 animate-pulse"></div>
                        <div className="h-4 bg-gray-600 rounded w-64 animate-pulse"></div>
                    </div>
                    <div className="h-10 bg-gray-600 rounded w-32 animate-pulse mt-4 sm:mt-0"></div>
                </div>

                {/* Table Skeleton */}
                <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden">
                    <div className="p-6 space-y-4">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="grid grid-cols-5 gap-4 items-center">
                                {/* CODE */}
                                <div className="h-4 bg-gray-600 rounded w-16 animate-pulse"></div>
                                {/* NAME */}
                                <div className="h-4 bg-gray-600 rounded w-32 animate-pulse"></div>
                                {/* SYMBOL */}
                                <div className="h-4 bg-gray-600 rounded w-12 animate-pulse"></div>
                                {/* EXCHANGE RATE */}
                                <div className="h-4 bg-gray-600 rounded w-20 animate-pulse"></div>
                                {/* ACTIONS */}
                                <div className="h-8 bg-gray-600 rounded w-12 animate-pulse"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <h2 className="text-2xl font-bold text-white">Currency</h2>
                    <p className="text-gray-400">
                        View, manage, and update all currencies and their details
                    </p>
                </div>
            </div>

            <div className={'flex justify-end'}>
                <button
                    onClick={() => setOpenEditModal(true)}
                    className="flex items-center space-x-2 bg-yellow-500 text-white px-4 py-2 rounded-lg hover:bg-yellow-600 transition-colors duration-200 mt-4 sm:mt-0">
                    <Plus className="h-4 w-4"/>
                    <span>Add</span>
                </button>
            </div>

            {/* currency table */}
            <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden">
                <div className="overflow-x-auto no-scrollbar">
                    <table className="min-w-full divide-y divide-gray-700">
                        <thead className="bg-gray-700">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                                CODE
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                                NAME
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider whitespace-nowrap">
                                SYMBOL
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider text-nowrap">
                                EXCHANGE RATE
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                                ACTIONS
                            </th>
                        </tr>
                        </thead>
                        <tbody className="bg-gray-800 divide-y divide-gray-700">
                        {currency.map((c) => (
                            <tr
                                key={c.id}
                                className="hover:bg-zinc-800/50 transition-colors"
                            >
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-white">
                                        {c?.code ?? "N/A"}
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-300">{c?.name ?? "N/A"}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-white">{c?.symbol ?? "N/A"}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-300">
                                        {Number(c?.exchange_rate).toFixed(2)}
                                    </div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center space-x-2">
                                        <button
                                            onClick={() => {
                                                setFormData({
                                                    code: c?.code,
                                                    name: c?.name,
                                                    symbol:  c?.symbol,
                                                    exchange_rate: Number(c?.exchange_rate).toFixed(2),
                                                })
                                                setSelectedId(c?.id);
                                                setOpenEditModal(true);
                                            }}
                                            className="px-3 py-1.5 text-xs font-medium border  rounded-lg hover:bg-green-500/10 transition-colors"
                                        >
                                            <Pencil className={'w-4 h-4'}/>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Confirm Modal */}
            {openEditModal && (
                <div className="fixed inset-0 z-50 flex items-center bg-black/60 justify-center"
                onClick={()=> {
                    handleCloseModal()
                }}>
                    <div
                         className="relative bg-gray-800 border border-gray-700 rounded-xl w-full max-w-md mx-4 p-6 shadow-xl"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}>
                        <div className={'flex flex-col gap-6'}>
                            <button className={'absolute top-4 right-4 bg-white/10 w-6 h-6 hover:text-red-500 duration-300 flex justify-center items-center rounded-full'}
                                    onClick={() => {
                                        handleCloseModal()
                                    }}
                            >
                                    <X className={'w-4 h-4'}/>
                            </button>
                            <div className={'flex justify-between items-center'}>
                               <h1 className={'text-2xl font-bold text-yellow-500'}>
                                   {
                                       selectedId ? 'Edit' : "Add"
                                   } Currency
                               </h1>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-white mb-1">
                                    Currency code {" "}
                                    <span className={'text-red-500'}>*</span>
                                </label>
                                <input
                                    type="text"
                                    value={formData?.code}
                                    min={0}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            code: e.target.value || '',
                                        }))
                                    }
                                    className="w-full bg-gray-900 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                                    placeholder='e.g "USD"'
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-white mb-1">
                                    Currency name {" "}
                                    <span className={'text-red-500'}>*</span>
                                </label>
                                <input
                                    type="text"
                                    value={formData?.name}
                                    min={0}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            name: e.target.value || '',
                                        }))
                                    }
                                    className="w-full bg-gray-900 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                                    placeholder="Currency name"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-white mb-1">
                                    Currency symbol {" "}
                                    <span className={'text-red-500'}>*</span>
                                </label>
                                <input
                                    type="text"
                                    value={formData?.symbol}
                                    min={0}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            symbol: e.target.value,
                                        }))
                                    }
                                    className="w-full bg-gray-900 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                                    placeholder="e.g. '$'"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-white mb-1">
                                    Exchange Rate {" "}
                                    <span className={'text-red-500'}>*</span>
                                </label>
                                <input
                                    type="number"
                                    value={formData?.exchange_rate}
                                    min={0}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            exchange_rate: e.target.value,
                                        }))
                                    }
                                    className="w-full bg-gray-900 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                                    placeholder="Enter exchange rate"
                                />
                            </div>
                        </div>

                        <div className=" mt-8">
                            <div className={'flex justify-end gap-3'}>
                                <button
                                    type="button"
                                    className="bg-gray-700 text-white hover:bg-gray-900 px-4 py-2 rounded-lg"
                                    onClick={() => handleCloseModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="bg-yellow-500 hover:bg-yellow-600 text-white duration-300 px-4 py-2 rounded-lg flex items-center gap-2"
                                    onClick={() => handleCreateAndUpdateCurrency(selectedId).then()}
                                    disabled={isUpdating}
                                >
                                    {isUpdating && (
                                        <Loader2 className={'w-4 h-4 animate-spin'}/>
                                    )} {" "} {selectedId ? 'Update' : "Add"}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Currency;